import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import MetaData from '../components/MetaData.js'
import { clearErrors, getAllProductsHome } from '../actions/productAction'
import { useSelector, useDispatch } from 'react-redux'
import Loader from '../components/Loader.js'
import { useAlert } from 'react-alert'
import { getAllCategories } from '../actions/categoryAction'
import { getbanner } from '../actions/userAction'
// import { Button } from './Styles';
// Import Swiper styles
// import "swiper/css";
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// import required modules
import {
  EffectFade,
  Autoplay,
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
} from 'swiper';

const Home = () => {
  const alert = useAlert()
  const dispatch = useDispatch()
  const { loading, error, products } = useSelector((state) => state.products)
  const { categories } = useSelector((state) => state.categories)
  const { banners } = useSelector((state) => state.banners)

  // console.log(products)

  useEffect(() => {
    if (error) {
      alert.error(error)
      dispatch(clearErrors())
    }
    dispatch(getAllProductsHome())
    dispatch(getAllCategories())
    dispatch(getbanner())
  }, [dispatch, error, alert])

  return (
    <>
      {/* {loading ? (
        <Loader />
      ) : (
        <> */}
      <MetaData title='E-Campus-kbmtr' />

      {/*<!-- Slider Section Start -->*/}

      <div
  id="carouselExampleFade"
  className="carousel slide carousel-fade customSliderHero"
  data-bs-ride="carousel"
>
  <div className="carousel-inner mt-5">
    <img style={{maxHeight:'470px',width:'100%'}} src="../assets/images/KBMTraining.webp" alt="KBM TR"/>
    {/*{banners &&
      banners.map((item, index) => (
        <div
          className={`carousel-item ${index === 0 ? "active" : ""}`}
          key={item._id}
        >
        <div className="carouselOverlay"></div>
          <img
            src={item.images[0]?.url}
            className="d-block w-100"
            alt={item.name}
          />
          <div className="carousel-caption d-none d-md-block">
          <div className="carouselContent">
            <h1>{item.name}</h1>
            <p>{item.description}</p>
            <p dangerouslySetInnerHTML={{ __html: item.description}}>
              {product?.description}
            </p>
          </div>
            <Link
              to="/shop"
              className="btn btn-primary btn-hover-dark"
            >
              Enroll Now
            </Link>
          </div>
        </div>
      ))}*/}
  </div>
  {/*<button
    className="carousel-control-prev"
    type="button"
    data-bs-target="#carouselExampleFade"
    data-bs-slide="prev"
  >
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button
    className="carousel-control-next"
    type="button"
    data-bs-target="#carouselExampleFade"
    data-bs-slide="next"
  >
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>*/}
</div>
      
      {/*<!-- Slider Section End -->*/}


      {/*<!-- Product Banner Section Start -->*/}
      {/*<div className='section bg-color-01'>*/}
      {/*  <div className='products-banner products-banner-active'>*/}
      {/*    <div className='swiper-container'>*/}
      {/*      <Swiper*/}
      {/*        slidesPerView={2}*/}
      {/*        spaceBetween={0}*/}
      {/*        navigation={false}*/}
      {/*        loop={true}*/}
      {/*        breakpoints={{*/}
      {/*          640: {*/}
      {/*            slidesPerView: 2,*/}
      {/*            spaceBetween: 0,*/}
      {/*          },*/}
      {/*          768: {*/}
      {/*            slidesPerView: 3,*/}
      {/*            spaceBetween: 10,*/}
      {/*          },*/}
      {/*          1024: {*/}
      {/*            slidesPerView: 4,*/}
      {/*            spaceBetween: 10,*/}
      {/*          },*/}
      {/*        }}*/}
      {/*        modules={[Navigation]}*/}
      {/*        className='mySwiper'*/}
      {/*      >*/}
      {/*        /!*{categories && categories.slice(0,4).map((item) => (*/}
      {/*                          <li key={item._id} className={splitLocation[1] === `shop/category/${item.name}` ? "active" : ``}>*/}
      {/*                              <Link to={`/shop/category/${item.name}`}>{item.name}</Link>*/}
      {/*                          </li>*/}
      {/*                      ))}*!/*/}
      {/*        {categories &&*/}
      {/*          categories.map((item) => (*/}
      {/*            <SwiperSlide key={item._id}>*/}
      {/*              <div className='swiper-slide'>*/}
      {/*                /!*<!-- Single Products Banner Start -->*!/*/}
      {/*                <div className='single-products-banner'>*/}
      {/*                  <img*/}
      {/*                    src={item.images[0]?.url}*/}
      {/*                    width='480'*/}
      {/*                    height='600'*/}
      {/*                    alt='Category'*/}
      {/*                  />*/}

      {/*                  <div className='products-banner-content'>*/}
      {/*                    <div className='banner-content-wrapper'>*/}
      {/*                      <h4 className='title'>*/}
      {/*                        <Link*/}
      {/*                          className='text-capitalize'*/}
      {/*                          to={`/shop/category/${item.name}`}*/}
      {/*                        >*/}
      {/*                          {item.name}*/}
      {/*                        </Link>*/}
      {/*                      </h4>*/}
      {/*                      <span className='products-count'>*/}
      {/*                        /!*{products && products.length} Products</span>*!/*/}
      {/*                        {*/}
      {/*                          products.filter(*/}
      {/*                            (product) => product.category === item.name*/}
      {/*                          ).length*/}
      {/*                        }{' '}*/}
      {/*                        Courses*/}
      {/*                      </span>*/}
      {/*                      <Link*/}
      {/*                        to={`/shop/category/${item.name}`}*/}
      {/*                        className='arrow'*/}
      {/*                      >*/}
      {/*                        <i className='pe-7s-angle-right'></i>*/}
      {/*                      </Link>*/}
      {/*                    </div>*/}
      {/*                  </div>*/}
      {/*                </div>*/}
      {/*                /!*<!-- Single Products Banner End -->*!/*/}
      {/*              </div>*/}
      {/*            </SwiperSlide>*/}
      {/*          ))}*/}
      {/*      </Swiper>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<!-- Product Banner Section End -->*/}

      {/*<!-- New Product Section Start -->*/}
      <div className='section section-padding'>
        <div className='container'>
          {/*<!-- Product Section Wrapper Start -->*/}
          <div className='product-section-wrapper'>
            <div className='row justify-content-center'>
              
              <div className='col-lg-12'>
                {/*<!-- Product Wrapper Start -->*/}
                <div className='product-wrapper product-active'>
                  {/*<!-- Product Top Wrapper Start -->*/}
                  <div className='product-top-wrapper'>
                    {/*<!-- Section Title Start -->*/}
                    <div className='section-title order-md-1'>
                      <h2 className='title'>AAT Courses</h2>
                    </div>
                    {/*<!-- Section Title End -->*/}

                    
                  </div>
                  {/*<!-- Product Top Wrapper End -->*/}

                  {/*<!-- Product Tabs Content Start -->*/}
                  <div className='product-tabs-content'>
                    <div className="text-center my-3" >
                      <p style={{fontSize:'19px'}}>Looking to advance your accounting career? Join our AAT Level 2, 3, and 4 courses with practical accounting training on Sage,
                        QuickBooks, Xero, IRIS and BrightPay along with work experience to boost employability.</p>
                      <p style={{fontSize:'19px'}}> Benefit from one-to-one support sessions and a high 92% pass rate, ensuring your success. Take the next step towards a rewarding career in accounting—enrol today!</p>
                    </div>
                    <div className='tab-content'>
                      <div className='tab-pane fade show active' id='tab1'>
                        <div className='swiper-container'>
                          <Swiper
                            slidesPerView={1}
                            spaceBetween={10}
                            navigation={true}
                            breakpoints={{
                              640: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                              },
                              768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                              },
                              1024: {
                                slidesPerView: 4,
                                spaceBetween: 20,
                              },
                            }}
                            modules={[Navigation]}
                            className='mySwiper'
                          >
                            <SwiperSlide>
                              <div className='swiper-slide courseSec no-flip'>
                                <div className='single-product'>
                                  <div className='product-content frontContent'>
                                    <img src="https://www.aat.org.uk/assets/images/shared/aat_logo.svg" alt="AAT LOGO"/>
                                  </div>
                                </div>
                              </div>
                            </SwiperSlide>
                            {products &&
                              products
                                .filter((product) => product.category === 'AAT Courses')
                                .map((product) => (
                                  <SwiperSlide key={product._id}>
                                    <div className='swiper-slide courseSec'>
                                      <div className='single-product'>
                                        <div className='product-content frontContent'>
                                          <h4 className='title'>
                                            <Link to={`/product/${product._id}`}>{product.name}</Link>
                                          </h4>
                                          <div className=''>
                                            <p>
                                              <span>{product.topic}</span> 
                                            </p>
                                          </div>
                                        </div>
                                        <div className="product-content backContent">
                                          <div
                                              dangerouslySetInnerHTML={{ __html: product?.description?.split(" ").slice(0, 20).join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),}}>
                                          </div>
                                          <ul className='product-meta'>
                                            <li>
                                              <Link className='action' to={`/product/${product._id}`}>
                                                <span>See Details</span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                ))}
                          </Swiper>
                        </div>
                      </div>
                      
                    </div>
                  </div>

                  {/*<div className="courseSec">
                    <div className="row">
                    {products &&
                      products
                        .filter((product) => product.tag === 'product')
                        .map((product) => (
                      <div key={product._id} className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/${product._id}`}>{product.name}</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>{product.topic}</span> {product.type}
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/${product._id}`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      ))}
                    </div>
                  </div>*/}
                  {/*<!-- Product Tabs Content End -->*/}
                </div>
                {/*<!-- Product Wrapper End -->*/}
              </div>
            </div>
          </div>
          {/*<!-- Product Section Wrapper End -->*/}
        </div>
      </div>
      {/*<!-- New Product Section End -->*/}

      

      {/*<!-- New Product Section Start -->*/}
      <div className='section section-padding greyBg'>
        <div className='container'>
          {/*<!-- Product Section Wrapper Start -->*/}
          <div className='product-section-wrapper'>
            <div className='row justify-content-center'>
              
              <div className='col-lg-12'>
                {/*<!-- Product Wrapper Start -->*/}
                <div className='product-wrapper product-active'>
                  {/*<!-- Product Top Wrapper Start -->*/}
                  <div className='product-top-wrapper'>
                    {/*<!-- Section Title Start -->*/}
                    <div className='section-title order-md-1'>
                      <h2 className='title'>Practical Trainings</h2>
                    </div>
                    {/*<!-- Section Title End -->*/}

                    
                  </div>
                  {/*<!-- Product Top Wrapper End -->*/}

                  {/*<!-- Product Tabs Content Start -->*/}
                  <div className='product-tabs-content'>
                    <div className="text-center my-3" >
                      <p style={{fontSize:'19px'}}>Already qualified in accounting but need hands-on experience? Our Practical Accounting Training offers real-world exposure with an ACCA Approved Gold Partner Chartered Accounting Firm. </p>
                      <p style={{fontSize:'19px'}}> Learn industry-leading software like Sage, QuickBooks, Xero, BrightPay, IRIS, and Excel, and receive job placement support to advance your career.</p>
                    </div>
                    <div className='tab-content'>
                      <div className='tab-pane fade show active' id='tab1'>
                        <div className='swiper-container'>
                          <Swiper
                            slidesPerView={1}
                            spaceBetween={10}
                            navigation={true}
                            breakpoints={{
                              640: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                              },
                              768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                              },
                              1024: {
                                slidesPerView: 4,
                                spaceBetween: 20,
                              },
                            }}
                            modules={[Navigation]}
                            className='mySwiper'
                          >
                            <SwiperSlide>
                              <div className='swiper-slide courseSec no-flip'>
                                <div className='single-product'>
                                  <div className='product-content frontContent'>
                                    <img src="https://www.acdap.org/images/acdap-transparent-logo.png" alt="ACDAP LOGO"/>
                                  </div>
                                </div>
                              </div>
                            </SwiperSlide>
                            {products &&
                              products
                                .filter((product) => product.category === 'Practical Trainings')
                                .map((product) => (
                                  <SwiperSlide key={product._id}>
                                    <div className='swiper-slide courseSec'>
                                      <div className='single-product'>
                                        <div className='product-content frontContent'>
                                          <h4 className='title'>
                                            <Link to={`/product/${product._id}`}>{product.name}</Link>
                                          </h4>
                                          <div className=''>
                                            <p>
                                              <span>{product.topic}</span> 
                                            </p>
                                          </div>
                                        </div>
                                        <div className="product-content backContent">
                                          <div
                                                                    dangerouslySetInnerHTML={{
                                                                      __html: product?.description
                                                                        ?.split(" ")
                                                                        .slice(0, 20)
                                                                        .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                                                    }}
                                                                  ></div>
                                          <ul className='product-meta'>
                                            <li>
                                              <Link className='action' to={`/product/${product._id}`}>
                                                <span>See Details</span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                ))}
                          </Swiper>
                        </div>
                      </div>
                      
                    </div>
                  </div>

                  {/*<!-- Product Tabs Content End -->*/}
                </div>
                {/*<!-- Product Wrapper End -->*/}
              </div>
            </div>
          </div>
          {/*<!-- Product Section Wrapper End -->*/}
        </div>
      </div>
      {/*<!-- New Product Section End -->*/}

      

      {/*<!-- New Product Section Start -->*/}
      {/*<div className='section section-padding'>*/}
      {/*  <div className='container'>*/}
      {/*    /!*<!-- Product Section Wrapper Start -->*!/*/}
      {/*    <div className='product-section-wrapper'>*/}
      {/*      <div className='row justify-content-center'>*/}
      {/*        */}
      {/*        <div className='col-lg-12'>*/}
      {/*          /!*<!-- Product Wrapper Start -->*!/*/}
      {/*          <div className='product-wrapper product-active'>*/}
      {/*            /!*<!-- Product Top Wrapper Start -->*!/*/}
      {/*            <div className='product-top-wrapper'>*/}
      {/*              /!*<!-- Section Title Start -->*!/*/}
      {/*              <div className='section-title order-md-1'>*/}
      {/*                <h2 className='title'>AAT Courses</h2>*/}
      {/*              </div>*/}
      {/*              /!*<!-- Section Title End -->*!/*/}

      {/*              */}
      {/*            </div>*/}
      {/*            /!*<!-- Product Top Wrapper End -->*!/*/}

      {/*            /!*<!-- Product Tabs Content Start -->*!/*/}
      {/*            <div className='product-tabs-content'>*/}
      {/*              <div className='tab-content'>*/}
      {/*                <div className='tab-pane fade show active' id='tab1'>*/}
      {/*                  <div className='swiper-container'>*/}
      {/*                    <Swiper*/}
      {/*                      slidesPerView={1}*/}
      {/*                      spaceBetween={10}*/}
      {/*                      navigation={true}*/}
      {/*                      breakpoints={{*/}
      {/*                        640: {*/}
      {/*                          slidesPerView: 1,*/}
      {/*                          spaceBetween: 10,*/}
      {/*                        },*/}
      {/*                        768: {*/}
      {/*                          slidesPerView: 2,*/}
      {/*                          spaceBetween: 20,*/}
      {/*                        },*/}
      {/*                        1024: {*/}
      {/*                          slidesPerView: 4,*/}
      {/*                          spaceBetween: 20,*/}
      {/*                        },*/}
      {/*                      }}*/}
      {/*                      modules={[Navigation]}*/}
      {/*                      className='mySwiper'*/}
      {/*                    >*/}
      {/*                      {products &&*/}
      {/*                        products*/}
      {/*                          .filter((product) => product.category === 'AAT')*/}
      {/*                          .map((product) => (*/}
      {/*                            <SwiperSlide key={product._id}>*/}
      {/*                              <div className='swiper-slide courseSec'>*/}
      {/*                                <div className='single-product'>*/}
      {/*                                  <div className='product-content frontContent'>*/}
      {/*                                    <h4 className='title'>*/}
      {/*                                      <Link to={`/product/${product._id}`}>{product.name}</Link>*/}
      {/*                                    </h4>*/}
      {/*                                    <div className=''>*/}
      {/*                                      <p>*/}
      {/*                                        <span>{product.topic}</span> */}
      {/*                                      </p>*/}
      {/*                                    </div>*/}
      {/*                                  </div>*/}
      {/*                                  <div className="product-content backContent">*/}
      {/*                                    <div*/}
      {/*                                                              dangerouslySetInnerHTML={{*/}
      {/*                                                                __html: product?.description*/}
      {/*                                                                  ?.split(" ")*/}
      {/*                                                                  .slice(0, 20)*/}
      {/*                                                                  .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),*/}
      {/*                                                              }}*/}
      {/*                                                            ></div>*/}
      {/*                                    <ul className='product-meta'>*/}
      {/*                                      <li>*/}
      {/*                                        <Link className='action' to={`/product/${product._id}`}>*/}
      {/*                                          <span>See Details</span>*/}
      {/*                                        </Link>*/}
      {/*                                      </li>*/}
      {/*                                    </ul>*/}
      {/*                                  </div>*/}
      {/*                                </div>*/}
      {/*                              </div>*/}
      {/*                            </SwiperSlide>*/}
      {/*                          ))}*/}
      {/*                    </Swiper>*/}
      {/*                  </div>*/}
      {/*                </div>*/}
      {/*                */}
      {/*              </div>*/}
      {/*            </div>*/}

      {/*            /!*<!-- Product Tabs Content End -->*!/*/}
      {/*          </div>*/}
      {/*          /!*<!-- Product Wrapper End -->*!/*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    /!*<!-- Product Section Wrapper End -->*!/*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<!-- New Product Section End -->*/}

      {/*<!-- New Product Section Start -->*/}
      {/*<div className='section section-padding greyBg'>*/}
      {/*  <div className='container'>*/}
      {/*    /!*<!-- Product Section Wrapper Start -->*!/*/}
      {/*    <div className='product-section-wrapper'>*/}
      {/*      <div className='row justify-content-center'>*/}
      {/*        */}
      {/*        <div className='col-lg-12'>*/}
      {/*          /!*<!-- Product Wrapper Start -->*!/*/}
      {/*          <div className='product-wrapper product-active'>*/}
      {/*            /!*<!-- Product Top Wrapper Start -->*!/*/}
      {/*            <div className='product-top-wrapper'>*/}
      {/*              /!*<!-- Section Title Start -->*!/*/}
      {/*              <div className='section-title order-md-1'>*/}
      {/*                <h2 className='title'>CPD Courses</h2>*/}
      {/*              </div>*/}
      {/*              /!*<!-- Section Title End -->*!/*/}

      {/*              */}
      {/*            </div>*/}
      {/*            /!*<!-- Product Top Wrapper End -->*!/*/}

      {/*            /!*<!-- Product Tabs Content Start -->*!/*/}
      {/*            <div className='product-tabs-content'>*/}
      {/*              <div className='tab-content'>*/}
      {/*                <div className='tab-pane fade show active' id='tab1'>*/}
      {/*                  <div className='swiper-container'>*/}
      {/*                    <Swiper*/}
      {/*                      slidesPerView={1}*/}
      {/*                      spaceBetween={10}*/}
      {/*                      navigation={true}*/}
      {/*                      breakpoints={{*/}
      {/*                        640: {*/}
      {/*                          slidesPerView: 1,*/}
      {/*                          spaceBetween: 10,*/}
      {/*                        },*/}
      {/*                        768: {*/}
      {/*                          slidesPerView: 2,*/}
      {/*                          spaceBetween: 20,*/}
      {/*                        },*/}
      {/*                        1024: {*/}
      {/*                          slidesPerView: 4,*/}
      {/*                          spaceBetween: 20,*/}
      {/*                        },*/}
      {/*                      }}*/}
      {/*                      modules={[Navigation]}*/}
      {/*                      className='mySwiper'*/}
      {/*                    >*/}
      {/*                      {products &&*/}
      {/*                        products*/}
      {/*                          .filter((product) => product.category === 'CPD')*/}
      {/*                          .map((product) => (*/}
      {/*                            <SwiperSlide key={product._id}>*/}
      {/*                              <div className='swiper-slide courseSec'>*/}
      {/*                                <div className='single-product'>*/}
      {/*                                  <div className='product-content frontContent'>*/}
      {/*                                    <h4 className='title'>*/}
      {/*                                      <Link to={`/product/${product._id}`}>{product.name}</Link>*/}
      {/*                                    </h4>*/}
      {/*                                    <div className=''>*/}
      {/*                                      <p>*/}
      {/*                                        <span>{product.topic}</span> */}
      {/*                                      </p>*/}
      {/*                                    </div>*/}
      {/*                                  </div>*/}
      {/*                                  <div className="product-content backContent">*/}
      {/*                                    <div*/}
      {/*                                                              dangerouslySetInnerHTML={{*/}
      {/*                                                                __html: product?.description*/}
      {/*                                                                  ?.split(" ")*/}
      {/*                                                                  .slice(0, 20)*/}
      {/*                                                                  .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),*/}
      {/*                                                              }}*/}
      {/*                                                            ></div>*/}
      {/*                                    <ul className='product-meta'>*/}
      {/*                                      <li>*/}
      {/*                                        <Link className='action' to={`/product/${product._id}`}>*/}
      {/*                                          <span>See Details</span>*/}
      {/*                                        </Link>*/}
      {/*                                      </li>*/}
      {/*                                    </ul>*/}
      {/*                                  </div>*/}
      {/*                                </div>*/}
      {/*                              </div>*/}
      {/*                            </SwiperSlide>*/}
      {/*                          ))}*/}
      {/*                    </Swiper>*/}
      {/*                  </div>*/}
      {/*                </div>*/}
      {/*                */}
      {/*              </div>*/}
      {/*            </div>*/}

      {/*            /!*<!-- Product Tabs Content End -->*!/*/}
      {/*          </div>*/}
      {/*          /!*<!-- Product Wrapper End -->*!/*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    /!*<!-- Product Section Wrapper End -->*!/*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<!-- New Product Section End -->*/}

      
      {/* </>
      )} */}
    </>
  )
}

export default Home
